import { getQuestionPaperTopics, getQuestionPapers, createTest } from './api'
import { createTestSlice } from './reducer'

const { resetQuestionPaperTopics } = createTestSlice.actions

export {
  getQuestionPaperTopics,
  resetQuestionPaperTopics,
  getQuestionPapers,
  createTest
}
